/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface TransitionsCopy {
  flowTitle: (args: { flow: string | number }) => string;
  addMoneyFlowTitle: string;
  backLabel: (args: { dealName: string | number; term: string | number }) => string;
  backLabelNoTerm: (args: { dealName: string | number }) => string;
  stepCounter: (args: { step: string | number; total: string | number }) => string;
  perAnnum: string;
  rateWithSuffix: (args: { rate: string | number }) => string;
  termsHeading: string;
  amountStep: {
    withdrawTitle: string;
    moveTitle: string;
    availableToWithdraw: (args: { amount: string | number }) => string;
    availableToMove: (args: { amount: string | number }) => string;
    partial: string;
    full: string;
    overBalance: (args: { amount: string | number }) => string;
    fifoNote: string;
    withdrawProjection: (args: { amount: string | number }) => string;
    stepUpGain: (args: { amount: string | number; rate: string | number }) => string;
    stepDownCost: (args: { amount: string | number }) => string;
    stepDownCostLabel: (args: { rate: string | number }) => string;
    noticeWindow: (args: { noticeStarts: string | number; noticeEnds: string | number }) => string;
    noticeStarts: (args: { noticeStarts: string | number }) => string;
    remainderNote: (args: { remaining: string | number; rate: string | number }) => string;
    confirmToBePaidBy: (args: { confirmBy: string | number; moneySentBy: string | number }) => string;
    confirmToStartNotice: (args: { confirmBy: string | number }) => string;
    noticeInfoLink: string;
    compareTerms: string;
    continue: string;
    nothingAvailableTitle: string;
    nothingAvailableBody: string;
    nothingToMoveTitle: string;
    nothingToMoveBody: string;
    backToHolding: string;
  };
  fact: {
    amount: string;
    moving: string;
    from: string;
    to: string;
    account: string;
    paidTo: string;
    confirmBy: string;
    receiveBy: string;
    noticeStarts: string;
    moneySentBy: string;
    switchCompletes: string;
    takesEffect: string;
    withdrawing: string;
    rateDuringWithdrawal: string;
    rateDuringSwitch: string;
    editOrCancelUntil: string;
    youllReceive: string;
    earningsDuringNotice: string;
    atLeast: (args: { value: string | number }) => string;
    newRateStarts: string;
    rateGuaranteedUntil: string;
    newGuaranteeUntil: string;
    newWithdrawalNotice: string;
    newTermStarts: string;
    costVsStaying: string;
    startsEarning: (args: { rate: string | number }) => string;
    extraEarningsAt: (args: { rate: string | number }) => string;
    months: (args: { count: number }) => string;
    amountOfTotal: (args: { amount: string | number; total: string | number }) => string;
    partialAmount: (args: { amount: string | number }) => string;
    fullAmount: (args: { amount: string | number }) => string;
    termWithRate: (args: { term: string | number; rate: string | number }) => string;
    perYear: (args: { amount: string | number }) => string;
    profitAtRate: (args: { amount: string | number; rate: string | number }) => string;
  };
  timelineStep: {
    title: string;
    today: string;
    noticeStarts: string;
    moneySent: string;
    weeksRemaining: (args: { weeks: number }) => string;
    noticeLength: (args: { months: string | number }) => string;
    minimumNoticeLength: (args: { months: number }) => string;
    payoutNote: string;
  };
  termStep: {
    title: string;
    intro: string;
    introWithHolding: (args: { amount: string | number; term: string | number; rate: string | number }) => string;
    balanceLabel: string;
    balanceContext: (args: { term: string | number; rate: string | number }) => string;
    stepUp: string;
    stepDown: string;
    current: string;
    noticeLine: (args: { months: number }) => string;
    currentConsequence: (args: { amount: string | number; rate: string | number }) => string;
    stepUpConsequence: string;
    stepDownConsequence: (args: { months: string | number }) => string;
    continueTo: (args: { direction: string | number; term: string | number }) => string;
    noOptions: string;
    alreadyRequested: (args: { amount: string | number }) => string;
  };
  moveAmount: {
    stepUpNote: (args: { months: string | number; startDate: string | number }) => string;
    stepDownNote: (args: { months: string | number; completesOn: string | number }) => string;
  };
  reviewStep: {
    withdrawTitle: string;
    stepUpTitle: string;
    stepDownTitle: string;
    confirmWithdraw: string;
    confirmStepUp: string;
    confirmStepDown: string;
    withdrawTerms: (args: { confirmBy: string | number; remaining: string | number; rate: string | number }) => string;
    withdrawTermsNoRemainder: (args: { confirmBy: string | number }) => string;
    stepUpTerms: (args: { startDate: string | number; months: number }) => string;
    stepDownTerms: (args: { sourceMonths: string | number; noticeRate: string | number; destinationTerm: string | number }) => string;
    stepDownTermsWithRemainder: (args: { sourceMonths: string | number; noticeRate: string | number; destinationTerm: string | number; remaining: string | number; sourceRate: string | number }) => string;
    withdrawAgreement: (args: { noticeStarts: string | number; moneySentBy: string | number }) => string;
    withdrawAgreementNoPayoutDate: (args: { noticeStarts: string | number; months: number }) => string;
    withdrawAgreementNoNotice: string;
    stepUpAgreement: (args: { months: number; startDate: string | number }) => string;
    stepDownAgreement: (args: { sourceMonths: string | number; noticeRate: string | number; completesOn: string | number }) => string;
    chooseAccount: string;
    accountRequired: string;
    conversion: (args: { name: string | number; accountCurrency: string | number; currency: string | number }) => string;
    changeAccount: string;
    payoutModalTitle: string;
  };
  noticePanel: {
    title: string;
    intro: string;
    cutOffTitle: string;
    cutOffBody: (args: { nextCutOff: string | number }) => string;
    earningTitle: string;
    earningBody: (args: { noticeRate: string | number; standardRate: string | number }) => string;
    flexibleTitle: string;
    flexibleBody: string;
    dismiss: string;
  };
  successStep: {
    withdrawTitle: string;
    stepUpTitle: string;
    stepDownTitle: string;
    withdrawBody: (args: { amount: string | number; moneySentBy: string | number }) => string;
    withdrawBodyNoPayoutDate: (args: { amount: string | number; noticeStarts: string | number; payoutNote: string | number }) => string;
    withdrawBodyNoNotice: (args: { amount: string | number }) => string;
    stepUpBody: (args: { amount: string | number; term: string | number; date: string | number }) => string;
    stepDownBody: (args: { amount: string | number; term: string | number; date: string | number }) => string;
    done: string;
  };
  detail: {
    title: (args: { kind: string | number }) => string;
    status: (args: { status: string | number }) => string;
    compareHeading: string;
    now: string;
    after: string;
    notice: string;
    noNotice: string;
    noticeUndecided: string;
    memberLine: string;
    delta: (args: { points: string | number }) => string;
    noticeBanner: (args: { rate: string | number }) => string;
    noticeBannerUntil: (args: { rate: string | number; until: string | number }) => string;
    exitBanner: (args: { rate: string | number }) => string;
    detailsHeading: string;
    rowAmount: string;
    rowMovingTo: string;
    rowNoticePeriod: string;
    rowRequested: string;
    rowNoticeEnds: string;
    keepsEarningNote: string;
    loadFailed: string;
  };
  addMoney: {
    title: string;
    holdingIntro: (args: { amount: string | number; term: string | number }) => string;
    minimum: (args: { amount: string | number }) => string;
    belowMinimum: (args: { amount: string | number }) => string;
    aboveMaximum: (args: { amount: string | number }) => string;
    aboveIsaAllowance: (args: { amount: string | number }) => string;
    aboveIsaAllowancePendingMove: (args: { amount: string | number; pending: string | number }) => string;
    isaPendingMoves: (args: { amount: string | number }) => string;
    reinvestLead: string;
    paidOutLead: string;
    perYear: (args: { amount: string | number }) => string;
    accrualLabel: string;
    calculatorLink: string;
    accountsHeading: string;
    accountsSubheading: string;
    personalTitle: string;
    personalDescription: string;
    ifIsaTitle: string;
    ifIsaDescription: string;
    ifIsaAllowance: (args: { amount: string | number }) => string;
    entityDescription: string;
    reviewCta: string;
    reviewTitle: (args: { dealName: string | number }) => string;
    rowAmountToAdd: string;
    rowAccount: string;
    rowYourRate: string;
    rowWithdrawalNotice: string;
    rowStartsEarning: string;
    rateWithGuarantee: (args: { rate: string | number; until: string | number }) => string;
    existingMoneyNote: (args: { existing: string | number }) => string;
    confirmCta: string;
    noAccounts: string;
  };
  errors: {
    quoteFailedTitle: string;
    quoteFailedBody: string;
    retry: string;
    submitFailed: string;
    duplicatePending: string;
    overBalance: string;
    coolingOff: string;
    profileExpired: string;
  };
}

export const transitionsSchema: NamespaceSchema = {
  namespace: "transitions",
  keys: {
    "flowTitle": ["flow"],
    "addMoneyFlowTitle": [],
    "backLabel": ["dealName", "term"],
    "backLabelNoTerm": ["dealName"],
    "stepCounter": ["step", "total"],
    "perAnnum": [],
    "rateWithSuffix": ["rate"],
    "termsHeading": [],
    "amountStep.withdrawTitle": [],
    "amountStep.moveTitle": [],
    "amountStep.availableToWithdraw": ["amount"],
    "amountStep.availableToMove": ["amount"],
    "amountStep.partial": [],
    "amountStep.full": [],
    "amountStep.overBalance": ["amount"],
    "amountStep.fifoNote": [],
    "amountStep.withdrawProjection": ["amount"],
    "amountStep.stepUpGain": ["amount", "rate"],
    "amountStep.stepDownCost": ["amount"],
    "amountStep.stepDownCostLabel": ["rate"],
    "amountStep.noticeWindow": ["noticeStarts", "noticeEnds"],
    "amountStep.noticeStarts": ["noticeStarts"],
    "amountStep.remainderNote": ["remaining", "rate"],
    "amountStep.confirmToBePaidBy": ["confirmBy", "moneySentBy"],
    "amountStep.confirmToStartNotice": ["confirmBy"],
    "amountStep.noticeInfoLink": [],
    "amountStep.compareTerms": [],
    "amountStep.continue": [],
    "amountStep.nothingAvailableTitle": [],
    "amountStep.nothingAvailableBody": [],
    "amountStep.nothingToMoveTitle": [],
    "amountStep.nothingToMoveBody": [],
    "amountStep.backToHolding": [],
    "fact.amount": [],
    "fact.moving": [],
    "fact.from": [],
    "fact.to": [],
    "fact.account": [],
    "fact.paidTo": [],
    "fact.confirmBy": [],
    "fact.receiveBy": [],
    "fact.noticeStarts": [],
    "fact.moneySentBy": [],
    "fact.switchCompletes": [],
    "fact.takesEffect": [],
    "fact.withdrawing": [],
    "fact.rateDuringWithdrawal": [],
    "fact.rateDuringSwitch": [],
    "fact.editOrCancelUntil": [],
    "fact.youllReceive": [],
    "fact.earningsDuringNotice": [],
    "fact.atLeast": ["value"],
    "fact.newRateStarts": [],
    "fact.rateGuaranteedUntil": [],
    "fact.newGuaranteeUntil": [],
    "fact.newWithdrawalNotice": [],
    "fact.newTermStarts": [],
    "fact.costVsStaying": [],
    "fact.startsEarning": ["rate"],
    "fact.extraEarningsAt": ["rate"],
    "fact.months": ["count"],
    "fact.amountOfTotal": ["amount", "total"],
    "fact.partialAmount": ["amount"],
    "fact.fullAmount": ["amount"],
    "fact.termWithRate": ["term", "rate"],
    "fact.perYear": ["amount"],
    "fact.profitAtRate": ["amount", "rate"],
    "timelineStep.title": [],
    "timelineStep.today": [],
    "timelineStep.noticeStarts": [],
    "timelineStep.moneySent": [],
    "timelineStep.weeksRemaining": ["weeks"],
    "timelineStep.noticeLength": ["months"],
    "timelineStep.minimumNoticeLength": ["months"],
    "timelineStep.payoutNote": [],
    "termStep.title": [],
    "termStep.intro": [],
    "termStep.introWithHolding": ["amount", "term", "rate"],
    "termStep.balanceLabel": [],
    "termStep.balanceContext": ["term", "rate"],
    "termStep.stepUp": [],
    "termStep.stepDown": [],
    "termStep.current": [],
    "termStep.noticeLine": ["months"],
    "termStep.currentConsequence": ["amount", "rate"],
    "termStep.stepUpConsequence": [],
    "termStep.stepDownConsequence": ["months"],
    "termStep.continueTo": ["direction", "term"],
    "termStep.noOptions": [],
    "termStep.alreadyRequested": ["amount"],
    "moveAmount.stepUpNote": ["months", "startDate"],
    "moveAmount.stepDownNote": ["months", "completesOn"],
    "reviewStep.withdrawTitle": [],
    "reviewStep.stepUpTitle": [],
    "reviewStep.stepDownTitle": [],
    "reviewStep.confirmWithdraw": [],
    "reviewStep.confirmStepUp": [],
    "reviewStep.confirmStepDown": [],
    "reviewStep.withdrawTerms": ["confirmBy", "remaining", "rate"],
    "reviewStep.withdrawTermsNoRemainder": ["confirmBy"],
    "reviewStep.stepUpTerms": ["startDate", "months"],
    "reviewStep.stepDownTerms": ["sourceMonths", "noticeRate", "destinationTerm"],
    "reviewStep.stepDownTermsWithRemainder": ["sourceMonths", "noticeRate", "destinationTerm", "remaining", "sourceRate"],
    "reviewStep.withdrawAgreement": ["noticeStarts", "moneySentBy"],
    "reviewStep.withdrawAgreementNoPayoutDate": ["noticeStarts", "months"],
    "reviewStep.withdrawAgreementNoNotice": [],
    "reviewStep.stepUpAgreement": ["months", "startDate"],
    "reviewStep.stepDownAgreement": ["sourceMonths", "noticeRate", "completesOn"],
    "reviewStep.chooseAccount": [],
    "reviewStep.accountRequired": [],
    "reviewStep.conversion": ["name", "accountCurrency", "currency"],
    "reviewStep.changeAccount": [],
    "reviewStep.payoutModalTitle": [],
    "noticePanel.title": [],
    "noticePanel.intro": [],
    "noticePanel.cutOffTitle": [],
    "noticePanel.cutOffBody": ["nextCutOff"],
    "noticePanel.earningTitle": [],
    "noticePanel.earningBody": ["noticeRate", "standardRate"],
    "noticePanel.flexibleTitle": [],
    "noticePanel.flexibleBody": [],
    "noticePanel.dismiss": [],
    "successStep.withdrawTitle": [],
    "successStep.stepUpTitle": [],
    "successStep.stepDownTitle": [],
    "successStep.withdrawBody": ["amount", "moneySentBy"],
    "successStep.withdrawBodyNoPayoutDate": ["amount", "noticeStarts", "payoutNote"],
    "successStep.withdrawBodyNoNotice": ["amount"],
    "successStep.stepUpBody": ["amount", "term", "date"],
    "successStep.stepDownBody": ["amount", "term", "date"],
    "successStep.done": [],
    "detail.title": ["kind"],
    "detail.status": ["status"],
    "detail.compareHeading": [],
    "detail.now": [],
    "detail.after": [],
    "detail.notice": [],
    "detail.noNotice": [],
    "detail.noticeUndecided": [],
    "detail.memberLine": [],
    "detail.delta": ["points"],
    "detail.noticeBanner": ["rate"],
    "detail.noticeBannerUntil": ["rate", "until"],
    "detail.exitBanner": ["rate"],
    "detail.detailsHeading": [],
    "detail.rowAmount": [],
    "detail.rowMovingTo": [],
    "detail.rowNoticePeriod": [],
    "detail.rowRequested": [],
    "detail.rowNoticeEnds": [],
    "detail.keepsEarningNote": [],
    "detail.loadFailed": [],
    "addMoney.title": [],
    "addMoney.holdingIntro": ["amount", "term"],
    "addMoney.minimum": ["amount"],
    "addMoney.belowMinimum": ["amount"],
    "addMoney.aboveMaximum": ["amount"],
    "addMoney.aboveIsaAllowance": ["amount"],
    "addMoney.aboveIsaAllowancePendingMove": ["amount", "pending"],
    "addMoney.isaPendingMoves": ["amount"],
    "addMoney.reinvestLead": [],
    "addMoney.paidOutLead": [],
    "addMoney.perYear": ["amount"],
    "addMoney.accrualLabel": [],
    "addMoney.calculatorLink": [],
    "addMoney.accountsHeading": [],
    "addMoney.accountsSubheading": [],
    "addMoney.personalTitle": [],
    "addMoney.personalDescription": [],
    "addMoney.ifIsaTitle": [],
    "addMoney.ifIsaDescription": [],
    "addMoney.ifIsaAllowance": ["amount"],
    "addMoney.entityDescription": [],
    "addMoney.reviewCta": [],
    "addMoney.reviewTitle": ["dealName"],
    "addMoney.rowAmountToAdd": [],
    "addMoney.rowAccount": [],
    "addMoney.rowYourRate": [],
    "addMoney.rowWithdrawalNotice": [],
    "addMoney.rowStartsEarning": [],
    "addMoney.rateWithGuarantee": ["rate", "until"],
    "addMoney.existingMoneyNote": ["existing"],
    "addMoney.confirmCta": [],
    "addMoney.noAccounts": [],
    "errors.quoteFailedTitle": [],
    "errors.quoteFailedBody": [],
    "errors.retry": [],
    "errors.submitFailed": [],
    "errors.duplicatePending": [],
    "errors.overBalance": [],
    "errors.coolingOff": [],
    "errors.profileExpired": [],
  },
};
